module.exports = __webpack_public_path__ + "static/media/sync.b6bf5ac0.svg";